import { getJson, postJson } from './client';

export interface LoginRequestPayload {
  username: string;
  password: string;
  turnstile?: string;
}

export interface LoginResponseUser {
  id: number;
  username: string;
  display_name?: string;
  [key: string]: unknown;
}

export interface LoginResponseBody {
  success: boolean;
  message: string;
  data: {
    user?: LoginResponseUser;
    roles?: unknown;
    token?: string | null;
    [key: string]: unknown;
  } | null;
}

const resolveLoginEndpoint = (turnstile?: string): string => {
  const token = turnstile ?? '';
  return `/api/user/login?turnstile=${encodeURIComponent(token)}`;
};

export interface UserTokenResponse {
  success: boolean;
  message: string;
  data: string | null;
  [key: string]: unknown;
}

export const loginUser = async (payload: LoginRequestPayload): Promise<LoginResponseBody> => {
  const { username, password, turnstile } = payload;
  return postJson<LoginResponseBody>(
    resolveLoginEndpoint(turnstile),
    { username, password },
    {
      includeAuth: false,
      resolveEndpoint: false,
      headers: {
        'new-api-user': '-1',
      },
    }
  );
};

export const fetchUserToken = async (userId: number | string): Promise<UserTokenResponse> => {
  const normalizedId = typeof userId === 'number' ? String(Math.trunc(userId)) : String(userId || '').trim();
  if (!normalizedId) {
    throw new Error('缺少用户 ID，无法请求系统访问令牌');
  }
  return getJson<UserTokenResponse>('/api/user/token', {
    resolveEndpoint: false,
    headers: {
      'new-api-user': normalizedId,
    },
    cache: 'no-store',
  });
};
